import React from "react";
import styles from "./Careers.module.css";
import FooterComponent from '../Footer/FooterComponent';

function Careers() {
    return (
        <div className={styles.careersPage}>
            {/* Hero Section */}
            <section className={styles.hero}>
                <h1 className={styles.headline}>Careers</h1>
                <p className={styles.subheadline}>
                    Join Toxbox AI – Shaping the Future of Enterprise AI
                </p>
                <p className={styles.description}>
                    Become part of a team that’s revolutionizing conversational AI for
                    enterprises, workflow automation, and intelligent virtual assistants.
                    Your work will empower businesses across fintech, healthcare,
                    e-commerce, education, and travel.
                </p>
            </section>

            {/* Open Positions Section */}
            <section className={styles.section}>
                <h2 className={styles.sectionTitle}>Open Positions</h2>
                <div className={styles.cards}>
                    <div className={styles.card}>
                        <h3>AI Research Scientist</h3>
                        <p>📍 Remote</p>
                    </div>
                    <div className={styles.card}>
                        <h3>Software Engineer (NLP)</h3>
                        <p>📍 San Francisco, CA</p>
                    </div>
                    <div className={styles.card}>
                        <h3>Customer Success Manager</h3>
                        <p>📍 New York, NY</p>
                    </div>
                    <div className={styles.card}>
                        <h3>Product Manager (AI Platforms)</h3>
                        <p>📍 London, UK</p>
                    </div>
                </div>
            </section>

            {/* Why Work Here Section */}
            <section className={styles.section}>
                <h2 className={styles.sectionTitle}>Why Work at Toxbox AI?</h2>
                <ul className={styles.benefits}>
                    <li>🚀 Work on cutting-edge AI technologies for global enterprises.</li>
                    <li>🤝 Collaborate with a diverse, innovative team.</li>
                    <li>🌍 Flexible work environment with remote opportunities.</li>
                    <li>💼 Competitive benefits and growth opportunities.</li>
                </ul>
            </section>

            {/* Apply Section */}
            <section className={styles.apply}>
                <h2 className={styles.sectionTitle}>Apply Today</h2>
                <p>
                    Explore career opportunities and apply to join our mission to
                    transform customer experiences with AI.
                </p>
                <a href="#open-roles" className={styles.cta}>
                    View Open Roles
                </a>
            </section>
        </div>
    );
}

export default Careers;
